module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('datepicker', {
    attrs: {
      "name": _vm.name,
      "value": _vm.value,
      "input-class": _vm.extraClasses,
      "format": "yyyy-MM-dd"
    },
    on: {
      "input": function($event) {
        _vm.input($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e78db49e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateField.vue
// module id = 173
// module chunks = 1